if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.thumbnails = this.querySelectorAll('.product-media-modal__content__nav__thumbnails .modal__thumbnail');
      this.image = this.querySelectorAll('.product-media-modal__content__image');
      if (this.thumbnails) {
        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', this.onThumbnailClick.bind(this,thumbnail));
        });
      }
    }

    onThumbnailClick(element) {
      console.log(element)
      this.thumbnails.forEach((other) => {
        other.classList.remove('active');
      });
      element.classList.add('active');
      const target = element.getAttribute('data-id');
      this.image.forEach((image) => {
        if (image.getAttribute('id') === target) {
            if (!image.classList.contains('active')) {
              image.classList.add('active');
            }
        } else {
          image.classList.remove('active');
        }
      });
      console.log(target)
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
